Flup.service("focus", function(flup){
   var that = this;
   that.focusTopElm = function($elms, animate, $elmToScroll){
      var minTop = null, $focusElm = null;
      $.each($elms, function(i, $elm){
         var top = $elm.offset().top;
         if(minTop === null || top < minTop) {
            minTop = top;
            $focusElm = $elm;
         }
      });
      that.focusElm($focusElm, animate, $elmToScroll);
   }

   that.focusElm = function($elm, animate, $elmToScroll){
      if(animate){
         if(!$elmToScroll){
            var $modal = $elm.closest("[data-modal]");
            $elmToScroll = $modal.length ? $modal : $('html, body');
         }
         $elmToScroll.animate({scrollTop: $elm.offset().top-150}, 250);
         setTimeout(function(){
            $elm.focus();
         }, 250);
      }else{
         $elm.focus();
      }
   }
});